import React from 'react';

import { LockedFilesSVG } from 'assets/img';
import { TextView } from 'components';
import UserInfo from 'templates/UserInfo';

const FriendlyScreen: React.FC = () => {
  return (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{ marginTop: '12%' }}
    >
      <UserInfo
        imageUrl={LockedFilesSVG}
        headingText={`Whoops! It seems you've stumbled upon a restricted page.`}
        subText={[]}
        buttonComponent={
          <div className="flex flex-col justify-center items-center ">
            <TextView
              text={`Reach out to your POC from Yucollect to get access`}
              color="#667085"
            />
            <div>
              <TextView text={` or  mail us at `} color="#667085" />
              <a className="mail_link" href="mailto:sales@yucollect.com">
                sales@yucollect.com
              </a>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default FriendlyScreen;
